import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';


let instance = null;
const init = () => {
  gsap.registerPlugin(ScrollTrigger);
  const targetElm = document.getElementById('js-intro');
  if(!targetElm) return;
  const containerElm = targetElm.querySelector('.js-container');
  const decoElm = targetElm.querySelector('.js-deco');
  const txtElm = targetElm.querySelector('.js-txt');
  gsap.set(txtElm, {opacity: 0});
  gsap.set(decoElm, {scale: 0});
  instance = gsap.timeline({
    scrollTrigger: {
      trigger: containerElm,
      start: "top center",
      end: "bottom bottom",
      markers: false,
      onEnter: () => {
        update('enter');
      },
      onEnterBack: () => {
        update('enterBack');
      },
      onLeave: () => {
        update('leave');
      },
      onLeaveBack: () => {
        update('leaveBack');
      },
    }
  })
}

const update = (state) => {
  const targetElm = document.getElementById('js-intro');
  const decoElm = targetElm.querySelector('.js-deco');
  const txtElm = targetElm.querySelector('.js-txt');
  if(instance) {
    switch (state) {
      case 'enter': 
      case 'enterBack':
        gsap.to(decoElm, {
          scale: 1,
          duration: 0.4,
          ease: 'power1.out',
          overwrite: true,
          onComplete: () => {
            gsap.to(txtElm, {
              opacity: 1,
              duration: 0.6,
              ease: 'power1.out',
            });
          }
        });
      break;
      case 'leave': 
      case 'leaveBack':
        gsap.to(txtElm, {
          opacity: 0,
          duration: 0.6,
          ease: 'power1.in',
          overwrite: true,
          onComplete: () => {
            switch (state) {
              case 'leave':
                gsap.to(decoElm, {
                  scale: 2,
                  duration: 0.4,
                  ease: 'power1.Out',
                });
              break;
              case 'leaveBack':
                gsap.to(decoElm, {
                  scale: 0,
                  duration: 0.4,
                  ease: 'power1.Out',
                });
              break;
            }
          }
        });
      break;
      default: 
      break;
    }
  }
}

const resize = () => {
  if(!instance) return;
  instance.scrollTrigger.refresh();
}

export {
  init,
  resize,
}